// organization related actions
export const SET_ORG_DETAILS = "SET_ORG_DETAILS";
export const RESET_ORG_DETAILS = "RESET_ORG_DETAILS";
export const GET_ORG_SPACES = "GET_ORG_SPACES";
